const ArrowRotate = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.97266 12C4.97266 8.13401 8.10666 5 11.9727 5C13.9466 5 15.3753 5.67948 16.7591 7H15C14.4477 7 14 7.44772 14 8C14 8.55228 14.4477 9 15 9H18.5C19.3284 9 20 8.32843 20 7.5V4C20 3.44772 19.5523 3 19 3C18.4477 3 18 3.44772 18 4V5.42301C16.3778 3.9219 14.5241 3 11.9727 3C7.00209 3 2.97266 7.02944 2.97266 12C2.97266 16.9706 7.00209 21 11.9727 21C15.8929 21 19.2253 18.4941 20.4603 14.9999C20.6443 14.4792 20.3714 13.9079 19.8507 13.7238C19.33 13.5398 18.7586 13.8127 18.5746 14.3334C17.6132 17.0536 15.0189 19 11.9727 19C8.10666 19 4.97266 15.866 4.97266 12Z"
      fill="currentColor"
    />
  </svg>
)

export default ArrowRotate
